import React, { forwardRef } from "react";

export interface ContainerProps {
  value: React.ReactNode;
  children: React.ReactNode;
  style?: React.CSSProperties;
  handleProps?: React.HTMLAttributes<any>;
}

export const Container = forwardRef<HTMLDivElement, ContainerProps>(
  (properties: ContainerProps, ref) => {
    const { value, children, handleProps, style, ...props } = properties;

    return (
      <div {...props} ref={ref} style={style}>
        <div {...handleProps}>{value}</div>
        <div>{children}</div>
      </div>
    );
  }
);
